<template>
  <div class="row">
    <div class="col-md-4">
      <b-form-group label="Tipo documento *">
        <v-select
          class="w-100"
          :class="{
              'v-select-danger': errors.has('custom-document-part-2.documentType')
              }"
          data-cy="document-type"
          data-vv-as="tipo documento"
          name="documentType"
          :options="optionDocumentType"
          v-model="documentForm.documentType"
          v-validate="'required'"
        >
          <template slot="no-options">
            no hay tipo documento para el criterio de búsqueda
          </template>
        </v-select>
        <div
          v-if="errors.has('custom-document-part-2.documentType')"
          class="con-text-validation span-text-validation-danger v-enter-to"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-2.documentType') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-4">
      <b-form-group label="Nº documento *">
        <b-form-input
          data-cy="document-number"
          data-vv-as="nº documento"
          name="documentNumber"
          v-model="documentForm.documentNumber"
          type="number"
          :state="errors.has('custom-document-part-2.documentNumber') ? false : null"
          v-validate="'required'"
          :formatter="maxLength"
        />
        <div
          v-if="errors.has('custom-document-part-2.documentNumber')"
          class="con-text-validation span-text-validation-danger v-enter-to"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-2.documentNumber') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-4">
      <InputCurrency
        v-model="documentForm.amount"
        id="amount"
        name="amount"
        data-cy="amount"
        label="Monto *"
        v-validate="'required|min:1'"
        :state="errors.has('custom-document-part-2.amount') ? false : null"
        :danger="errors.has('custom-document-part-2.amount')"
        :danger-text="errors.first('custom-document-part-2.amount')"
        data-vv-as="monto"
      />
    </div>
    <div class="col-md-6">
      <b-form-group label="Emitida por *">
        <b-form-input
          data-cy="emited-by"
          data-vv-as="emitida por"
          name="emitedBy"
          v-model="documentForm.emitedBy"
          :state="errors.has('custom-document-part-2.emitedBy') ? false : null"
          v-validate="'required'"
          maxLength="150"
        />
        <div
          v-if="errors.has('custom-document-part-2.emitedBy')"
          class="con-text-validation span-text-validation-danger v-enter-to"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-2.emitedBy') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <b-button
        data-cy="add-document-button"
        variant="primary"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        @click="addDocument()"
      >
        Agregar Documento
      </b-button>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';

import InputCurrency from '@/components/InputCurrency';

export default {
  components: { InputCurrency },
  directives: {
    Ripple
  },
  data() {
    return {
      documentForm: {
        amount: 0,
        documentType: '',
        documentNumber: '',
        emitedBy: ''
      },
      optionDocumentType: [
        { value: 'boleta', label: 'Boleta' },
        { value: 'factura', label: 'Factura' }
      ]
    };
  },
  methods: {
    maxLength(value) {
      return String(value).substring(0, 15);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addDocument() {
      const isValid = await this.validateForm('custom-document-part-2');

      if (!isValid) {
        return;
      }

      const row = {
        ...this.documentForm
      };

      this.$emit('add-document', row);

      this.documentForm.amount = 0;
      this.documentForm.documentNumber = '';
      this.documentForm.documentType = '';
      this.documentForm.emitedBy = '';

      await this.$validator.reset();
    }
  }
};
</script>
